export default __webpack_public_path__ + "static/logo-das-ohr-v2-full-cutout-black-32e52179b57af1e18ad98adc5a7434cf.png";